var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var Bin = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 18 20" }),
        React.createElement("path", { d: "M13,0.5 C13.2761424,0.5 13.5,0.723857625 13.5,1 L13.5,1 L13.5,3.5 L17,3.5 C17.2761424,3.5 17.5,3.72385763 17.5,4 C17.5,4.27614237 17.2761424,4.5 17,4.5 L17,4.5 L15.5,4.5 L15.5,19 C15.5,19.2761424 15.2761424,19.5 15,19.5 L15,19.5 L3,19.5 C2.72385763,19.5 2.5,19.2761424 2.5,19 L2.5,19 L2.5,4.5 L1,4.5 C0.723857625,4.5 0.5,4.27614237 0.5,4 C0.5,3.72385763 0.723857625,3.5 1,3.5 L1,3.5 L4.5,3.5 L4.5,1 C4.5,0.723857625 4.72385763,0.5 5,0.5 L5,0.5 Z M14.5,4.5 L3.5,4.5 L3.5,18.5 L14.5,18.5 L14.5,4.5 Z M7,6.5 C7.27614237,6.5 7.5,6.72385763 7.5,7 L7.5,7 L7.5,15 C7.5,15.2761424 7.27614237,15.5 7,15.5 C6.72385763,15.5 6.5,15.2761424 6.5,15 L6.5,15 L6.5,7 C6.5,6.72385763 6.72385763,6.5 7,6.5 Z M11,6.5 C11.2761424,6.5 11.5,6.72385763 11.5,7 L11.5,7 L11.5,15 C11.5,15.2761424 11.2761424,15.5 11,15.5 C10.7238576,15.5 10.5,15.2761424 10.5,15 L10.5,15 L10.5,7 C10.5,6.72385763 10.7238576,6.5 11,6.5 Z M12.5,1.5 L5.5,1.5 L5.5,3.5 L12.5,3.5 L12.5,1.5 Z" })));
};
export default Bin;
